import React from 'react';
import Styles from './ContactUs.module.scss';
import family from '../../images/ImagesSA/AboutUs/family.png';
import whitePhone from '../../images/ImagesSA/AboutUs/whitePhone.png';
import salud from '../../images/ImagesSA/AboutUs/salud.png';
import classnames from "classnames";

const ContactUs: React.FC = () => {
    return (
        <div className={Styles.backGround + " row "}>
            <div className="container">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className={classnames(Styles.marginRow, "row mb-5 mt-5")}>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center" >
                            <h5 className={Styles.title}>¿Quieres comunicarte con un asesor?</h5>
                        </div>
                    </div>
                    <div className={classnames(Styles.content, "row justify-content-center")}>
                        <div className="col-lg-7 col-md-7 col-sm-7 col-xs-12" >
                            <div className={classnames(Styles.marginRow, "row")}>
                                <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 align-self-center">
                                    <span>Con respaldo de:</span>
                                    <img src={salud} className="img-fluid" alt="Imagen empresa salud" />
                                </div>
                                <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                    <div className="row mt-3">
                                        <div className="col-lg-3 col-md-3 col-xs-3 col-sm-3 col-3 align-self-center">
                                            <img src={whitePhone} className="img-fluid" alt="Imagen teléfono" />
                                        </div>
                                        <div className="col-lg-9 col-md-9 col-xs-3 col-sm-9 col-9">
                                            <div className="mb-2">
                                                <span >Contáctanos</span>
                                            </div>
                                            <sub className="small">
                                                A nivel nacional<br/> 1700-776 776 <br/>(02) 394 8130 <br/>Azuay: (07) 245 6005
                                            </sub>
                                        </div>
                                   </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-auto col-md-auto col-sm-auto col-xs-12">
                            <img src={family} className="img-fluid" alt="Imagen familia" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
